import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { FormattedMessage, injectIntl, type IntlShape } from 'react-intl'
import { colors } from 'shared/assets/styles'
import { CaptionText, TinyText } from 'app/common/typography'
import type { EventMetadata } from 'shared/store/metadata'
import { eventsDefinitions } from 'shared/store/metadata'
import type { NutritionShortDTO } from 'shared/types'
import { Collapsible } from 'app/common/collapsible'
import { SPACING } from 'app-v2/design-tokens'
import { Spacer } from 'app-v2/design-systems'

const NutritionType = {
    PORTION: 0,
    SHARE: 1
}

const { text, grey, grey30 } = colors
type Props = {
    nutritions: Array<NutritionShortDTO>,
    sendMeta: EventMetadata => void,
    isMenu?: boolean,
    intl: IntlShape
}

type State = {
    isOpened: boolean
}

class _NutritionalValues extends Component<Props, State> {
    state = {
        isOpened: false
    }

    handleCollapseClick = (e: Event) => {
        e.preventDefault()
        const isOpened = !this.state.isOpened
        if (!isOpened) {
            const sendMeta = this.props.sendMeta
            const meta = eventsDefinitions.NUTRITION
            sendMeta(meta)
        }
        this.setState({
            isOpened
        })
    }

    renderNutritionalValues(title: string, type: number) {
        const { nutritions } = this.props
        return (
            <NutritionContainer>
                <FormattedMessage id={title}>
                    {(label: string) => (
                        <StyledTinyText color={grey} center>
                            {label}
                        </StyledTinyText>
                    )}
                </FormattedMessage>
                {nutritions.map((nutrition, index) => (
                    <NutritionalText key={index}>
                        {type === NutritionType.PORTION
                            ? nutrition.portion + ' ' + nutrition.unit
                            : nutrition.share + ' ' + nutrition.unit}
                    </NutritionalText>
                ))}
            </NutritionContainer>
        )
    }

    render() {
        const { nutritions, isMenu = false, intl } = this.props
        const { isOpened } = this.state

        return (
            <Wrapper onClick={e => this.handleCollapseClick(e)}>
                <Collapsible
                    labelKey="product.nutritional.title"
                    isOpened={isOpened}
                    color={text}>
                    {isMenu ? (
                        <>
                            <Spacer />

                            <NutritionalText>
                                {intl.formatMessage({
                                    id: 'product.nutritional.menu.unavailable'
                                })}
                            </NutritionalText>
                        </>
                    ) : (
                        <Fragment>
                            <BottomBorder>
                                <Container>
                                    <TitleContainer>
                                        <EmptyContainer />
                                        {nutritions.map((nutrition, index) => (
                                            <NutritionalText key={index}>
                                                <FormattedMessage
                                                    id={nutrition.item}
                                                />
                                            </NutritionalText>
                                        ))}
                                    </TitleContainer>
                                    {this.renderNutritionalValues(
                                        'product.nutritional.portion',
                                        NutritionType.PORTION
                                    )}
                                    {this.renderNutritionalValues(
                                        'product.nutritional.share',
                                        NutritionType.SHARE
                                    )}
                                </Container>
                            </BottomBorder>
                            <Wrapper>
                                <FormattedMessage id="product.nutritional.notice">
                                    {(label: string) => (
                                        <StyledTinyText color={grey} center>
                                            {label}
                                        </StyledTinyText>
                                    )}
                                </FormattedMessage>
                            </Wrapper>
                        </Fragment>
                    )}
                </Collapsible>
            </Wrapper>
        )
    }
}

const NutritionalText = styled(CaptionText)`
    color: ${text};
    padding-top: 10px;
    padding-bottom: 5px;
`

const StyledTinyText = styled(TinyText)`
    padding-bottom: 7px;
`

const Container = styled.section`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: auto;
    margin: 0 auto;
    padding-top: 20px;
`

const TitleContainer = styled.div`
    width: 50%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
`

const NutritionContainer = styled.div`
    width: 25%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    text-align: center;
`

const EmptyContainer = styled.div`
    padding-bottom: 20px;
`

const BottomBorder = styled.div`
    border-bottom: solid 1px ${grey30};
    padding-bottom: 10px;
`

const Wrapper = styled.div`
    padding: ${SPACING.XS} 0;
    cursor: pointer;
`

export const NutritionalValues = injectIntl(_NutritionalValues)
